import Header from "../components/Header";
import Footer from "../components/Footer";

const Funding = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header showAdminLink />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-16">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading text-navy font-bold">Funding</h1>
        <p className="mt-4 text-base text-slate-600 max-w-3xl">
          We help clients understand funding readiness and provide guidance on the documentation and steps often required to
          pursue business or personal funding opportunities.
        </p>

        <section className="mt-10 space-y-4">
          <h2 className="text-lg font-semibold text-navy">Typical focus areas</h2>
          <ul className="list-disc pl-6 text-slate-600 space-y-2">
            <li>Funding readiness review</li>
            <li>Document preparation guidance</li>
            <li>Basic business profile readiness</li>
            <li>Next-step planning and timelines</li>
          </ul>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Funding;
